export enum SortDirection {
  asc = 1,
  desc = -1
}

export enum ElasticIndices {
  search = "advanced_search_data",
  lookup = "advanced_search_lookup"
}

export enum ElasticTypes {
  accountBasicInfo = "",
  accountType = "AccountType",
  builtAs = "BuiltAs",
  city = "City",
  filingNo = "FilingNo",
  improvementInfo = "ImprovementInfo",
  improvementType = "ImprovementType",
  landAbstract = "LandAbstract",
  landAttribute = "LandAttribute",
  occupancyCode = "OccupancyCode",
  owner = "Owner",
  propertyAddress = "PropertyAddress",
  quality = "Quality",
  saleInformation = "SaleInformation",
  saleRecordingNo = "SaleRecordingNo",
  stateParcelNumber = "StateParcelNumber",
  streetAddress = "StreetAddress",
  subdivision = "Subdivision",
  subdivisionAttributes = "SubdivisionAttributes",
  taxAuthority = "TaxAuthority",
  taxDistrict = "TaxDistrict",
  zipCode = "ZipCode",
  geo_location = "geo_location"
}

export enum LogLevels {
  log = 1,
  info = 2,
  debug = 4,
  warning = 8,
  error = 16,
  verbose = log | info | debug | warning | error
}

export enum ValueTypes {
  single = 1,
  pair = 2,
  array = 4,
  string = 8,
  number = 16,
  boolean = 32,
  date = 64,
  object = 128,
  currency = 256,
  percent = 512,
  any = single | pair | array | string | number | boolean | date | currency | percent
}

export interface IPaginator {
  total: number;
  limit: number;
  rows: Array<any>;
  page: number;
  pageSize: number;
  pageLinks: any;
  sortie: ISortie;
  setPageLinks: any;
}

export interface ISortie {
  column: string;
  direction: SortDirection;
}

export interface INode {
  name: string;
  formSection: number;
  dependants?: Array<IDependent>;
  isDisabled: boolean;
  options: IOptions;
  search: ISearch;
  type: Array<ValueTypes>;
  values: any;
}

export interface IOptions {
  elasticIndex: string;
  elasticType: string;
  query?: string | any;
  buildQuery?: any;
  aggs?: {};
  sort?: {};
  size?: number;
  source?: string[];
  filterPath?: string[];
  display: { delim: string, value: string[], label: string[] };
  values: Array<any>;
  min?: number | Date;
  max?: number | Date;
}

export interface ISearch {
  elasticIndex: string;
  elasticType: string;
  auto: boolean;
  query?: string | any;
  buildQuery?: any;
  aggs?: {};
  sort?: {};
  source?: string[];
  filterPath?: string[];
  values: { data: Array<any>, count: number };
}

export interface IDependent {
  name: string;
  populate: boolean;
}

export interface IElasticResult {
  took: number;
  timed_out: boolean;
  _shards: IShard;
  hits: IHit;
}

export interface IShard {
  total: number;
  successful: number;
  failed: number;
}

export interface IHit {
  total: number;
  max_score: number;
  hits: Array<ISource>;
}

export interface ISource {
  _index: string;
  _type: string;
  _id: string;
  _score: number;
  _source: any;
}

export interface ILogStashLog {
  source: string;
  created?: Date;
  logType: string[] | number[];
  arguments: {};
  message: string;
}

export interface IPrefetch {
  count: number;
  over10k: boolean;
  requests: number;
  remainder: number;
}

export interface ISearchObj {
  displayColumns: Array<any>;
  hardStop?: number;
  hasResults: boolean;
  preFetch: IPrefetch;
  countQuery: any;
  searchQuery: any;
  accountMilestones?: Array<string>;
  rowCount: number;
  rows: Array<any>;
  searchTime: number;
  totalHits: number;
  resultMessage: string;
}

export interface IReportDefinition {
  key: string;
  title: string;
  fields: Array<IFieldDefinition>;
  excludes?: string;
  width?: string;
  minWidth?: string;
  nestedPrime?: string;
  innerHits?: string;
  nestedChildren?: string;
  nestedPath?: any;
  queryStructure?: IQueryStructure;
}

export interface IQueryStructure {
  acctIncludes: any;
  buildingNested: any;
  buildingInnerHits: any;
  usesNested: any;
  usesInnerHits: any;
  stylesNested: any;
  stylesInnerHits: any;
  salesNested: any;
  salesInnerHits: any;
  landSegmentsNested?: any;
  landSegmentsInnerHits?: any;
}

export interface IFieldDefinition {
  label: string;
  fieldName: string;
  sortName: string;
  compute?: { requires: string, operation: string, variables: Array<string> };
  width?: string;
  minWidth?: string;
  order: number;
  display: boolean;
  export: boolean;
  format: any;
}

export interface ISelectedItem {
  label: string;
  value: any;
}
